import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { createChild } from 'web/store/modules/pages';
import { getFlipper, getLocaleCodes } from 'web/store/modules/company';
import { getPageBuilder } from 'web/store/modules/pageBuilder';
import { FLIPPER_INTERNATIONALIZATION } from '../../../../constants/flippers';
import BuilderLanguagesMenu from '../components/BuilderLanguagesMenu';

const mapStateToProps = state => ({
  currentPage: getPageBuilder(state),
  flipperEnabled: getFlipper(state, FLIPPER_INTERNATIONALIZATION),
  locales: getLocaleCodes(state),
});

const mapDispatchToProps = dispatch => ({
  dispatch,
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const {
    currentPage, flipperEnabled, locales,
  } = stateProps;
  const { dispatch } = dispatchProps;

  const { locale: currentLocale, parent: parentId, parentPage: currentPageParent } = currentPage;

  const parentPage = !parentId ? currentPage : currentPageParent;

  const enabledLocalePages = [
    parentPage,
    ...parentPage.children,
  ];

  const enabledLocales = enabledLocalePages.map(page => page.locale);
  const enableableLocales = locales.filter(locale => !enabledLocales.includes(locale));

  return {
    createPageForLocale: locale => (
      dispatch(createChild(parentPage, locale))
        .then(({ data: { page: { id } } }) => dispatch(push(`/admin/page/edit/${id}`)))
    ),
    currentLocale,
    enabledLocalePages,
    enableableLocales,
    hide: !flipperEnabled || locales.length <= 1 || !currentPage,
    ...ownProps,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(BuilderLanguagesMenu);
